import { Injectable } from '@angular/core';
import { ScreenLoadingComponent } from './screen-loading.component';
import { combineLatest, map, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ScreenLoadingPresenter {
  view!: ScreenLoadingComponent;
  
  private destroy$ = new Subject<void>();

  setView(view: ScreenLoadingComponent): void {
    this.view = view;
    this.isLoading();
  }

  onDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  isLoading(): void {
    if (this.view.loadingList$ && this.view.loadingList$.length > 0) {
      this.view.combinedLoading$ = combineLatest(this.view.loadingList$).pipe(
        map((values) => values.some((v) => v))
      );
    } else {
      this.view.combinedLoading$ = this.view.loading$;
    }
  }

}
